














































import { Component, Vue, Prop } from 'vue-property-decorator'
import moment from 'moment'

@Component
export default class AppChangelog extends Vue {
  @Prop() readonly data!: Array<any>

  private separator = ': '
  // Bugfix(BF), NF(New Features), BC(Breaking Change), I(Improvement)
  private categories = {
    BF: 'Bug fixes',
    NF: 'New Features',
    BC: 'Breaking Changes',
    I: 'Improvements'
  }

  // Categorize each changes based on category
  categorizeChanges (changes: Array<any>) {
    const categoryKeys = Object.keys(this.categories)

    // Make new object from categories array
    const legendObject = categoryKeys.reduce((object, key) => ({ ...object, [key]: [] }), {})

    changes.forEach(change => {
      const legend = change.substring(0, change.indexOf(this.separator))
      const value = change.substr(change.indexOf(this.separator) + 1)
      if (!legend || !categoryKeys.includes(legend)) {
        return
      }
      legendObject[legend].push(value)
    })
    return legendObject
  }

  get filteredData () {
    if (!this.data) {
      return []
    }
    return this.data
      .filter(changelog => changelog.version && changelog.time) // remove changes that doesnt have version & time
      .map((changelog) => {
        return {
          ...changelog,
          time: moment(changelog.time).format('MMMM DD, YYYY'),
          changes: this.categorizeChanges(changelog.changes)
        }
      })
  }

  isChangesEmpty (changes: object) {
    let isEmpty = true
    Object.keys(changes).forEach(categoryKey => {
      if (changes[categoryKey].length) {
        isEmpty = false
      }
    })
    return isEmpty
  }
}
